import Box from "@mui/material/Box";
import grey from "@mui/material/colors/grey";
import { useMemo } from "react";
import Txt from "../typography/Txt";
import Flx from "../layout/Flx";
import UserAvatar from "./UserAvatar";
import { PersonAddAlt1Outlined } from "@mui/icons-material";
import { Tooltip } from "@mui/material";

const AvatarStackWithAction = ({
  sx,
  items,
  label,
  labelSx,
  size = 24,
  onAddTooltip,
  onAddClick,
}) => {
  const styles = useMemo(() => {
    return {
      ...sx,
    };
  }, [sx]);

  const labelStyles = useMemo(() => {
    return {
      color: "#33475b",
      fontSize: "13px",
      ...labelSx,
    };
  }, [labelSx]);
  return (
    <Flx column sx={styles} className="avatar-stack-with-action" gap={0}>
      <Txt sx={labelStyles}>{label}</Txt>
      <Flx wrap>
        {items?.map((item, i) => (
          <UserAvatar
            size={size}
            key={item?._id}
            showTooltip
            sx={{
              border: "1.5px solid #ffffff",
              marginLeft: i === 0 ? 0 : -0.7,
            }}
            label={item}
          />
        ))}
        {onAddClick && (
          <Tooltip title={onAddTooltip || "Add"} arrow>
            <Box onClick={onAddClick} sx={{ cursor: "pointer" }}>
              <UserAvatar
                size={size}
                sx={{
                  // cursor: "pointer",
                  border: `1px solid ${grey[600]}`,
                  background: "#ffffff",
                  color: grey[700],
                }}
              >
                <PersonAddAlt1Outlined />
              </UserAvatar>
            </Box>
          </Tooltip>
        )}
      </Flx>
    </Flx>
  );
};

export default AvatarStackWithAction;
